import React from "react";
import PaymentReportRow, { CELL_STYLE, mapPaymentReports } from "./PaymentReportRow";
import { getStatusDates, pickStatusDate } from "./paymentDates";

export default function EFTPaymentList(props) {
    return (
        <>
            {mapPaymentReports(props.data, props.offset, props.limit, (report) => (
                <TableRow
                    program={report.program}
                    patientID={report.patient_id}
                    firstName={report.first_name}
                    lastName={report.last_name}
                    dob={report.date_of_birth}
                    memberNum={report.member_id}
                    dos={report.date_of_service}
                    claimData={report.claim_data}
                    amount={parseFloat(report.claim_data.program_benefit).toFixed(2)}
                    eftID={report.claim_data.trace_id}
                    status={report.claim_status}
                />
            ))}
        </>
    );
}

// EFT is the only report that distinguishes "Sent to bank" from "Paid".
function paidStatusText(paid_date, status) {
    if (paid_date == "" || paid_date == null) return "";

    const timeDifference = (new Date() - new Date(paid_date)) / (1000 * 60 * 60 * 24);
    let text = timeDifference >= 10 ? "Paid" : "Sent to bank";

    if (status == "pm_approved") {
        text = "Approved";
    } else if (status == "Maximizer-Hold" || status == "Max-Ben EDI Hold" || status == "Max-Ben Hold" || status == "exception") {
        text = "Pending";
    }
    return text;
}

function TableRow(props) {
    const dates = getStatusDates(props.claimData, props.dos, { splitTime: true });

    return (
        <PaymentReportRow
            {...props}
            statusDate={pickStatusDate(dates)}
            idCell={
                <td style={{ lineHeight: "1.49em" }}>
                    <span style={{ fontSize: "0.75em" }}>
                        <strong> {props.eftID} </strong>
                    </span>
                </td>
            }
            statusCell={<td style={CELL_STYLE}>{dates.paid_date != null ? paidStatusText(dates.paid_date, props.status) : props.status}</td>}
        />
    );
}


